import { useEffect, useRef } from "react";
import { BrowserMultiFormatReader } from "@zxing/browser";

export default function QrScanner({ onScan }) {
  const videoRef = useRef(null);
  const controlsRef = useRef(null);

  useEffect(() => {
    const codeReader = new BrowserMultiFormatReader();
    let active = true;

    if (videoRef.current) {
      codeReader.decodeFromVideoDevice(
        undefined, // default camera
        videoRef.current,
        (result, error, controls) => {
          controlsRef.current = controls;

          if (result && active) {
            onScan(result.getText());
            active = false;
            setTimeout(() => (active = true), 2000); // avoid spamming
          }
        }
      );
    }

    return () => {
      if (controlsRef.current) {
        controlsRef.current.stop(); // ✅ Correct way to stop scanner
      }
    };
  }, [onScan]);

  return (
    <div className="rounded-lg overflow-hidden">
      <video ref={videoRef} className="w-full h-auto" />
    </div>
  );
}
